import React from 'react';
import './entrada.css';

/**
 * Moldura das telas de entrada (Login.dc.html): a marca EGORA à esquerda, sobre o
 * marfim, e o conteúdo à direita. No celular a marca fica em cima.
 * Usada pelo login, pela redefinição de senha e pela configuração do segundo fator.
 */
export default function EntradaMoldura({ children }) {
  return (
    <div className="sj entrada">
      <section className="entrada__marca" aria-label="EGORA">
        <img className="entrada__logo" src="/marca/egora-logo.png" alt="EGORA, gestão jurídica by SINTER" />
        <p className="entrada__frase">Prazos, processos e clientes do seu escritório no mesmo lugar.</p>
        <div className="entrada__selo">
          <span className="sj-icone sj-icone--sm" aria-hidden="true">lock</span>
          Conexão protegida e verificação em duas etapas
        </div>
      </section>
      <main className="entrada__conteudo">
        <div className="entrada__caixa">{children}</div>
      </main>
    </div>
  );
}

/** Cabeçalho de cada passo: ícone opcional, título e texto de apoio. */
export function EntradaCabeca({ icone, tom, titulo, texto }) {
  return (
    <div className="entrada__cabeca">
      {icone && (
        <span className={`sj-vazio__icone entrada__icone${tom ? ` entrada__icone--${tom}` : ''}`} aria-hidden="true">
          <span className="sj-icone">{icone}</span>
        </span>
      )}
      <h1 className="titulo-pagina entrada__titulo">{titulo}</h1>
      {texto && <p className="entrada__texto">{texto}</p>}
    </div>
  );
}

/** Erro do passo: sempre anunciado (role="alert"), com ícone e texto. */
export function EntradaErro({ children }) {
  if (!children) return null;
  return (
    <div className="entrada__erro" role="alert">
      <span className="sj-icone sj-icone--cheio" aria-hidden="true">error</span>
      <span>{children}</span>
    </div>
  );
}
